import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Clinic } from '../models/clinic.model';
import { User } from '../models/user.model';
import { environment } from '../../environments/environment';
import { DoctorSearchResponse } from '../models/doctor-search-response.model';
import { ClinicDoctorProfileDto } from '../models/clinic-doctor-profile.model';
import { ClinicStatus } from '../enums/clinic-status.enum';
import { ClinicStatusResponse } from '../models/clinic-status-response.model';
import { env } from 'node:process';

@Injectable({
  providedIn: 'root',
})
export class ClinicService {
  private apiUrl = environment.APP_BASE_URL + '/clinic-onboarding';
  private employeeUrl = environment.APP_BASE_URL + '/clinic-portal/user-onboarding';

  private clinicProfile = environment.APP_BASE_URL + '/clinic-portal/user-profile';

  constructor(private http: HttpClient) {}

  public createClinic(clinic: Clinic): Observable<Clinic> {
    return this.http.post<Clinic>(`${this.apiUrl}/create`, clinic);
  }

  public getClinic(): Observable<Clinic> {
    return this.http.get<Clinic>(`${this.apiUrl}`);
  }

  public updateClinic(clinic: Clinic): Observable<Clinic> {
    return this.http.put<Clinic>(`${this.apiUrl}`, clinic);
  }

  public createEmployee(user: User): Observable<User> {
    return this.http.post<User>(`${this.employeeUrl}/employee/create`, user);
  }

  public searchDoctors(searchTerm: string): Observable<DoctorSearchResponse[]> {
    return this.http.get<DoctorSearchResponse[]>(`${this.employeeUrl}/search/list`, {
      params: { searchTerm },
    });
  }

  public getClinicDoctorProfiles(): Observable<ClinicDoctorProfileDto[]> {
    return this.http.get<ClinicDoctorProfileDto[]>(`${this.clinicProfile}/clinic-profile`);
  }

  public getClinicStatus(): Observable<ClinicStatusResponse> {
    return this.http.get<ClinicStatusResponse>(`${this.clinicProfile}/clinic-status`);
  }
}
